module.exports = __webpack_public_path__ + "static/media/Back_2.f5338e65.jpg";